import { HttpStatusCode } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { filter, map, Observable } from 'rxjs';
import { CultureFacade } from '../cultures/facade/cultures.facade';
import { REPLY, RESPONSE } from '@boels/helpers';
import { FastifyReply } from 'fastify';

@Injectable({
  providedIn: 'root',
})
export class RedirectService {
  #response = inject<ResponseInit>(RESPONSE, { optional: true });
  #reply = inject<FastifyReply>(REPLY, { optional: true });
  #router = inject(Router);
  #cultureFacade = inject(CultureFacade);

  redirect(label: string, statusCode: HttpStatusCode): Observable<void> {
    return this.#cultureFacade.getActiveCulture().pipe(
      filter(Boolean),
      map((culture) => {
        label = label.startsWith('/') ? label.replace('/', '') : label;
        if (this.#reply) {
          // prevent caching of redirected pages
          this.#reply
            .headers({
              'Cache-Control': 'no-store, no-cache, must-revalidate',
            })
            .redirect(`/${culture}/${label}`, statusCode);
        } else {
          this.#router.navigateByUrl(`/${culture}/${label}`);
        }
        return undefined;
      }),
    );
  }

  setStatusCode(statusCode: HttpStatusCode | number) {
    if (this.#response) {
      this.#response.status = statusCode;
    }
  }

  noCaching(): void {
    if (this.#response) {
      this.#response.headers = {
        ...this.#response.headers,
        'Cache-Control': 'no-store, no-cache, must-revalidate',
        'Content-type': 'text/html;charset=UTF-8',
      };
    }
  }
}
